import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { HeaderStyled, ButtonMenu, HeaderWrapper } from './styles';

const PageHeader = ({ idEnterprise }) => {
    const currentUserRole = Number(sessionStorage.getItem('currentUserRole'));
    const segment = useSelector((state) => state.auth.currentSegment);
    const navigate = useNavigate();
    const params = useParams();
    const [currentRole, setCurrentRole] = useState(null);

    const { search } = useLocation();
    const queryParams = new URLSearchParams(search);
    const isDemonstration = queryParams.get('demo');

    const tabs =
        segment === 2
            ? currentRole === 5
                ? [
                      { key: 'users', label: 'Usuários' },
                      { key: 'performance', label: 'Desempenho' },
                      { key: 'reports', label: 'Relatórios' },
                      { key: 'goals', label: 'Metas' }
                  ]
                : [
                      { key: 'engagement', label: 'Engajamento' },
                      { key: 'users', label: 'Usuários' },
                      { key: 'properties', label: 'Propriedades' },
                      { key: 'action_plan', label: 'Plano de Ação' },
                      { key: 'check_agro', label: 'Check Agro' },
                      { key: 'performance', label: 'Desempenho' }
                  ]
            : currentUserRole === 5
            ? [
                  { key: 'users', label: 'Usuários' },
                  { key: 'performance', label: 'Desempenho' },
                  { key: 'reports', label: 'Relatórios' },
                  { key: 'goals', label: 'Metas' }
              ]
            : [
                  { key: 'engagement', label: 'Engajamento' },
                  { key: 'users', label: 'Usuários' },
                  { key: 'properties', label: 'Propriedades' },
                  //   { key: 'visits', label: 'Visitas' },
                  { key: 'action_plan', label: 'Plano de Ação' },
                  { key: 'check_agro', label: 'Check Agro' },
                  { key: 'courses', label: 'Saber Mais' },
                  { key: 'reports', label: 'Relatórios' },
                  { key: 'goals', label: 'Metas' },
                  { key: 'performance', label: 'Desempenho' }
              ];

    const tabParams = params.tab ?? tabs[0].key;

    const handleClickTab = (clickedTab) => {
        navigate(`/${currentRole}/empresa/geral/${idEnterprise}/${clickedTab}${isDemonstration ? '?demo=1' : ''}`);
    };

    const handleRule = () => {
        switch (currentUserRole) {
            case 1:
                return setCurrentRole('admin');
            case 6:
                return setCurrentRole('assistente');
            case 4:
                return setCurrentRole('coordenador');
            case 5:
                return setCurrentRole('supervisor');
            case 9:
                return setCurrentRole('admin_consultoria');
        }
    };

    useEffect(() => {
        handleRule();
    }, []);

    return (
        <HeaderWrapper>
            <HeaderStyled>
                {tabs.map((tab) => (
                    <ButtonMenu
                        key={tab.key}
                        onClick={() => handleClickTab(tab.key)}
                        style={
                            tab.key !== tabParams
                                ? { borderRadius: '8px 8px 0px 0px', fontSize: '13px', fontWeight: 600 }
                                : {
                                      borderRadius: '8px 8px 0px 0px',
                                      backgroundColor: '#3A6647',
                                      color: '#ffffff',
                                      fontWeight: 600,
                                      fontSize: '14px'
                                  }
                        }
                    >
                        <h3>{tab.label}</h3>
                    </ButtonMenu>
                ))}
            </HeaderStyled>
        </HeaderWrapper>
    );
};

export default PageHeader;
